import { Component } from '@angular/core';

import { ActionButtonComponent, ButtonComponent, ButtonToolComponent, DualButtonComponent } from '@camelot/ui';

import { TestIdDirective } from '@camelot/testing-harness';

@Component({
    imports: [ActionButtonComponent, ButtonComponent, ButtonToolComponent, DualButtonComponent, TestIdDirective],
    template: `
    <cam-button camTestId="cam-button">Click me</cam-button>
    <cam-button-tool camTestId="cam-button-tool" icon="edit" />
    <cam-action-button camTestId="cam-action-button" [actions]="this.actions" />
    <cam-dual-button camTestId="cam-dual-button" [first]="this.first" [second]="this.second" />
  `
})
export class UiButtonsCase {
  public actions = [{ callback: () => void 0, icon: 'add', label: 'Add' }];
  public first = { callback: () => void 0, icon: 'list', label: 'First' };
  public second = { callback: () => void 0, icon: 'map', label: 'Second' };
}
